<block-ui>
    <div class="container" *ngIf="this.lessonPlan">
        <div class="row justify-content-center">
            <h3 style="text-align: center;">Edit Lesson Plan</h3>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit($event.submitter.id)">
            <div class="row">
                <div class="col">
                    <label class="column-label">Title</label>
                    <input type="text" formControlName="title" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['title'].errors }" />
                    <!-- <div *ngIf="f['title'].errors" class="invalid-feedback">
                        <div *ngIf="f['title'].errors['required']">Title is required</div>
                        <div *ngIf="f['title'].errors['minLength']">Title must have at least {{ this.TITLE_MIN_LENGTH }} characters</div>
                        <div *ngIf="f['title'].errors['maxLength']">Title cannot have emore than {{ this.TITLE_MAX_LENGTH }}</div>
                    </div> -->
                </div>
                <div class="col">
                    <label class="column-label">Due Date</label>
                    <input type="date" formControlName="dueDate" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['dueDate'].errors }" />
                    <!-- <div *ngIf="f['dueDate'].errors" class="invalid-feedback">
                        <div *ngIf="f['dueDate'].errors['required']">Due Date is required</div>
                    </div> -->
                </div>
            </div>
            <div class="row">                
                <label class="column-label" for="description">Description: </label>
                <textarea id="description" rows="4" formControlName="description"></textarea>
                <!-- <div *ngIf="f['description'].errors" class="invalid-feedback">
                    <div *ngIf="f['description'].errors['required']">Description is required</div>
                </div> -->
            </div>
            <div class="row">
                <h2 class="col-10 table-title">Plan Members</h2>
                <button class="col-2" type="button" (click)="addPlanMember()">Add</button>
            </div>
            <ng-container *ngIf="planMembers" formArrayName="planMembers">
                <ng-container *ngFor="let planMember of planMembers.controls; let i = index">
                    <div *ngIf="this.editPlanMemberIndex === i" style="background-color: lightblue;" [formGroup]="planMember">
                        <div class="row">
                            <span class="col-1" *ngIf="planMember.controls.accepted.value == true">
                                <i class="fa fa-check-circle-o" aria-label="Accepted" style="cursor:pointer;"
                                title="Accepted"></i>
                            </span>
                            <span class="col-1" *ngIf="planMember.controls.accepted.value == false">
                                <i class="fa fa-ban" aria-label="Rejected" style="cursor:pointer;"
                                title="Rejected"></i>
                            </span>
                            <span class="col-1" *ngIf="planMember.controls.accepted.value == null">
                                <i class="fa fa-circle-o" aria-label="Pending" style="cursor:pointer;"
                                title="Pending"></i>    
                            </span>
                            <mat-form-field *ngIf="!planMember.controls.id?.value" class="col-11" appearance="fill">
                                <input matInput type="text" formControlName="emailAddress" placeholder="Email Address">
                            </mat-form-field>
                            <span class="col-11 px-3" *ngIf="planMember.controls.id?.value">{{ planMember.controls.emailAddress.value }}</span>
                        </div>
                        <div class="row">
                            <mat-checkbox class="col-4" formControlName="canUpdate">Can Update </mat-checkbox>
                            <button class="col-4 delete-btn" type="button" (click)="this.editPlanMemberIndex = -1">Close Edit</button>
                            <button class="col-4 delete-btn" type="button"  (click)="deletePlanMember(i)">Delete</button>
                        </div>
                    </div>
                    <div *ngIf="this.editPlanMemberIndex != i" class="row" (click)="this.editPlanMemberIndex = i;">
                        <div *ngIf="planMember.controls.accepted.value == true" class="col-1">
                            <i class="fa fa-check-circle-o" aria-label="Accepted" style="cursor:pointer;"
                            title="Accepted"></i>
                        </div>
                        <div *ngIf="planMember.controls.accepted.value == false" class="col-1">
                            <i class="fa fa-times" aria-label="Rejected" style="cursor:pointer;"
                            title="Rejected"></i>
                        </div>
                        <div *ngIf="planMember.controls.accepted.value == null" class="col-1">
                            <i class="fa fa-circle-o" aria-label="Pending" style="cursor:pointer;"
                            title="Pending"></i>
                        </div>
                        <div class="col-8">{{ planMember.controls.emailAddress.value }}</div>
                        <div class="col-3" style="font-size:smaller;">{{ (planMember.controls.canUpdate.value ? 'Can Update' : 'No Update') }}</div>
                    </div>
                </ng-container>
            </ng-container>
            <div class="row">
                <h2 class="col-10 table-title">Plan Steps</h2>
                <button type="button" class="col-2"(click)="addPlanItem()">Add</button>
            </div>
            <ng-container *ngIf="planItems" formArrayName="planItems">
                <ng-container *ngFor="let planItem of planItems.controls; let i = index">
                    <div *ngIf="this.editPlanStepIndex === i" style="background-color: lightblue;" [formGroup]="planItem">
                        <div class="row">
                            <mat-form-field class="col-12" appearance="fill">
                                <input matInput type="text" formControlName="value" placeholder="What the viewer should do for this step">
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field class="col-6" appearance="fill">
                                <mat-select formControlName="type">
                                    <mat-option *ngFor="let option of itemTypes" [value]="option.value">
                                        {{option.display}}                            
                                      </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!-- <mat-checkbox class="col-4" formControlName="isActive" placeholder="Is Shown to viewers">Is Active: </mat-checkbox> -->
                            <span class="col-6">
                                <button (click)="this.editPlanStepIndex = -1;" type="button" >
                                    Close Edit
                                </button>
                                <button class="delete-btn" (click)="deletePlanItem(i)" type="button" >
                                    Delete
                                </button>
                            </span>
                        </div>
                    </div>
                    <div *ngIf="this.editPlanStepIndex != i" [ngClass]="i % 2 == 0 ? 'evenRow' : 'oddRow'" class="row lesson-form-row">
                        <div class="col-1" style="max-width:50px;">{{ planItem.controls.sequence.value }}</div>
                        <div class="col-2" style="max-width:100px;padding:0;">
                            <span style="padding:0">
                                <button name=disabledDown *ngIf="i == planItems.controls.length - 1" disabled>
                                    <i class="fa fa-arrow-down" aria-hidden="true"></i>
                                </button>
                                <button name=enabledDown *ngIf="i < (planItems.controls.length - 1)" 
                                    (click)="moveStep(i, 1);">
                                    <i class="fa fa-arrow-down" aria-hidden="true"></i>
                                </button>
                                <button name=enabledUp *ngIf="i > 0"
                                    (click)="moveStep(i, -1);">
                                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                </button>
                                <button name=enabledUp *ngIf="i == 0" disabled>
                                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                </button>
                            </span>
                        </div>
                        <div class="col-9" style="padding:0;" [class.column-label]="planItem.controls.type.value === 'LABEL'" (click)="this.editPlanStepIndex = i;">
                            {{ planItem.controls.value.value }}
                        </div>
                        <!-- <div class="col-2" style="padding:0;" style="max-width:50px" >
                            {{ (planItem.controls.isActive.value ? 'Active' : 'Inactive') }}
                        </div> -->
                    </div>
                </ng-container>
            </ng-container>
            <div class="row">
                <p *ngIf="!form.valid">Complete the form to enable button.</p>
                <button class="col-6" id=submit name=submit type="submit" [disabled]="!form.valid">Save Changes But Don't Email</button>
                <button class="col-6" id=emailChanges name=emailChanges type="submit" [disabled]="!form.valid">Save Changes and Email Them</button>
            </div>
        </form>
    </div>
</block-ui>